export default (sidebarData, addressResponse) => ({
  customer_name: sidebarData.customer_name || '',
  company: sidebarData.company || '',
  street_1: addressResponse.street_1 || '',
  street_2: addressResponse.street_2 || '',
  zip: addressResponse.zip || '',
  city: addressResponse.city || '',
  state: addressResponse.state || '',
  country: addressResponse.country,
});
